var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { analytics } from 'app/utils/segment';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { ConfirmModal } from 'components/shared/confirmModal/components/confirmModal';
import { getRequestID } from 'components/shared/util/request';
import { withFlows, withQueues } from 'hocs';
import { useNotifications } from 'hooks/useNotifications';
import PrettyNumber from '../PrettyNumber';
const DEFAULT_ACTION_AXIS_X = 1800;
const DEFAULT_ACTION_AXIS_Y = 700;
const DEFAULT_ACTION_PROPS = {
    badges: [],
    childIds: [],
    connectionLabel: 'arrow',
    icon: null,
    isAction: false,
    isEditable: false,
    isRemovable: false,
    overlay: [],
    parentId: null,
    payload: null,
    text: '',
    pageX: DEFAULT_ACTION_AXIS_X,
    pageY: DEFAULT_ACTION_AXIS_Y,
};
const NewFlowModal = ({ isShown, onClose, number, flows, queues, }) => {
    const notify = useNotifications();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { organization: { default_queue: defaultQueueId }, } = useSelector((state) => state.settings.organization);
    const onCloseClick = useCallback(() => {
        analytics.phoneCreateFlowFormCancelled();
        onClose();
    }, [onClose]);
    const onConfirm = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        analytics.phoneCreateFlowFormSubmitted();
        if (!number) {
            return;
        }
        setIsLoading(true);
        const initNodeId = getRequestID();
        const queueNodeId = getRequestID();
        try {
            const { data: defaultQueue } = yield queues.getQueue(defaultQueueId);
            const newFlow = {
                channel: 'pstn_phone',
                active: false,
                location: number.e164_format,
                name: `Call flow for ${number.e164_format}`,
                actions: [
                    Object.assign(Object.assign({}, DEFAULT_ACTION_PROPS), { id: initNodeId, nodeType: FlowNodeTypes.INIT, text: 'Incoming Call' }),
                    Object.assign(Object.assign({}, DEFAULT_ACTION_PROPS), { icon: 'users', id: queueNodeId, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.QUEUE, pageY: DEFAULT_ACTION_AXIS_Y + 120, payload: {
                            queue: {
                                label: defaultQueue.name,
                                value: defaultQueue.id,
                            },
                            language: 'en-GB',
                        }, parentId: initNodeId, text: defaultQueue.name }),
                ],
            };
            const { data: { id, name }, } = yield flows.create(newFlow);
            notify({
                title: 'Flow created',
                text: `Flow was succesfully created as "${name}"`,
                className: 'success',
                time: 5000,
                icon: 'done',
            });
            navigate(`/settings/phone/flow/${id}`);
        }
        catch (_a) {
            notify({
                title: 'An error occurred',
                text: 'An error occurred when trying to create the flow',
                icon: 'exclamation',
                className: 'danger',
            });
        }
        onClose();
    }), [
        setIsLoading,
        defaultQueueId,
        flows,
        navigate,
        notify,
        number,
        queues,
        onClose,
    ]);
    return (_jsx(ConfirmModal, Object.assign({ isShown: isShown, headline: "New flow", cancelText: "Cancel", confirmText: "Create", confirmProps: { isLoading, variant: 'primary' }, cancel: onCloseClick, confirm: onConfirm }, { children: _jsxs("span", { children: ["Create new flow for number", ' ', _jsx("strong", { children: _jsx(PrettyNumber, { number: number }) }), "?"] }) })));
};
export default withQueues(withFlows(NewFlowModal));
